import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import InvestorProtectedRoute from '../components/InvestorProtectedRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AdminInvestorsPage = lazy(() => import('../pages/admin/investors/page'));
const AdminInvestmentsPage = lazy(() => import('../pages/admin/investments/page'));
const AdminProfitsPage = lazy(() => import('../pages/admin/profits/page'));
const AdminPeriodsPage = lazy(() => import('../pages/admin/periods/page'));
const AdminFinancialPeriodsPage = lazy(() => import('../pages/admin/financial-periods/page'));
const AdminMessagesPage = lazy(() => import('../pages/admin/messages/page'));
const AdminReportsPage = lazy(() => import('../pages/admin/reports/page'));
const AdminAuditLogsPage = lazy(() => import('../pages/admin/audit-logs/page'));
const InvestorLoginPage = lazy(() => import('../pages/investor/login/page'));
const InvestorDashboardPage = lazy(() => import('../pages/investor/dashboard/page'));
const InvestorInvestmentsPage = lazy(() => import('../pages/investor/investments/page'));
const InvestorProfitsPage = lazy(() => import('../pages/investor/profits/page'));
const InvestorReportsPage = lazy(() => import('../pages/investor/reports/page'));
const InvestorMessagesPage = lazy(() => import('../pages/investor/messages/page'));
const InvestorSettingsPage = lazy(() => import('../pages/investor/settings/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const InvestorDashboard = lazy(() => import('../pages/investor/dashboard/page'));
const InvestorInvestments = lazy(() => import('../pages/investor/investments/page'));
const InvestorProfits = lazy(() => import('../pages/investor/profits/page'));
const InvestorContractProfits = lazy(() => import('../pages/investor/contract-profits/page'));
const InvestorReports = lazy(() => import('../pages/investor/reports/page'));
const InvestorMessages = lazy(() => import('../pages/investor/messages/page'));
const InvestorSettings = lazy(() => import('../pages/investor/settings/page'));
const InvestorLogin = lazy(() => import('../pages/investor/login/page'));

const InvestmentRequestsPage = lazy(() => import('../pages/admin/investment-requests/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/dashboard',
    element: (
      <ProtectedRoute>
        <AdminDashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/investors',
    element: (
      <ProtectedRoute>
        <AdminInvestorsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/investments',
    element: (
      <ProtectedRoute>
        <AdminInvestmentsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/profits',
    element: (
      <ProtectedRoute>
        <AdminProfitsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/periods',
    element: (
      <ProtectedRoute>
        <AdminPeriodsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/financial-periods',
    element: (
      <ProtectedRoute>
        <AdminFinancialPeriodsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/messages',
    element: (
      <ProtectedRoute>
        <AdminMessagesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/reports',
    element: (
      <ProtectedRoute>
        <AdminReportsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/audit-logs',
    element: (
      <ProtectedRoute>
        <AdminAuditLogsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/investment-requests',
    element: <ProtectedRoute><InvestmentRequestsPage /></ProtectedRoute>
  },
  {
    path: '/investor/dashboard',
    element: <InvestorProtectedRoute><InvestorDashboard /></InvestorProtectedRoute>,
  },
  {
    path: '/investor/investments',
    element: <InvestorProtectedRoute><InvestorInvestments /></InvestorProtectedRoute>,
  },
  {
    path: '/investor/profits',
    element: <InvestorProtectedRoute><InvestorProfits /></InvestorProtectedRoute>,
  },
  {
    path: '/investor/contract-profits',
    element: <InvestorProtectedRoute><InvestorContractProfits /></InvestorProtectedRoute>,
  },
  {
    path: '/investor/reports',
    element: <InvestorProtectedRoute><InvestorReports /></InvestorProtectedRoute>,
  },
  {
    path: '/investor/messages',
    element: <InvestorProtectedRoute><InvestorMessages /></InvestorProtectedRoute>,
  },
  {
    path: '/investor/settings',
    element: <InvestorProtectedRoute><InvestorSettings /></InvestorProtectedRoute>,
  },
  {
    path: '/investor/login',
    element: <InvestorLogin />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
